import { useLocalStorage } from '@vueuse/core'
import { defineStore } from 'pinia'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

/**
 * 支持的语言配置
 */
// export const LANGUAGE_CONFIG: Record<string, { name: string; nativeName: string }> = {
//   'en-US': { name: 'English', nativeName: 'English' },
//   'zh-CN': { name: 'Chinese', nativeName: '中文' },
//   'id-ID': { name: 'Indonesian', nativeName: 'Bahasa Indonesia' },
//   'th-TH': { name: 'Thai', nativeName: 'ไทย' },
//   'ur-PK': { name: 'Urdu', nativeName: 'اردو' },
//   'vi-VN': { name: 'Vietnamese', nativeName: 'Tiếng Việt' },
//   'my-MM': { name: 'Burmese', nativeName: 'မြန်မာ' }
// }
export const LANGUAGE_CONFIG: { key: string; name: string; nativeName: string }[] = [
  { key: 'en-US', name: 'English', nativeName: 'English' },
  { key: 'zh-CN', name: 'Chinese', nativeName: '中文' },
  { key: 'id-ID', name: 'Indonesian', nativeName: 'Bahasa Indonesia' },
  { key: 'th-TH', name: 'Thai', nativeName: 'ไทย' },
  { key: 'ur-PK', name: 'Urdu', nativeName: 'اردو' },
  { key: 'vi-VN', name: 'Vietnamese', nativeName: 'Tiếng Việt' },
  { key: 'my-MM', name: 'Burmese', nativeName: 'မြန်မာ' }
]

export const useI18nStore = defineStore('i18nStore', () => {
  const { t, locale } = useI18n()

  const langStorage = useLocalStorage('__K__LANG', locale.value)
  const fixAppLang = () => {
    locale.value = langStorage.value
  }
  fixAppLang()

  const setAppLang = (val: string) => {
    langStorage.value = val
    locale.value = val
    fixAppLang()
  }

  const appLang = computed(() => langStorage.value)
  const currentLanguageInfo = computed(() =>
    LANGUAGE_CONFIG.find((x) => x.key == langStorage.value)
  )
  const supportLanguageList = computed(() => LANGUAGE_CONFIG)

  const reset = () => {}

  return { langStorage, reset, setAppLang, appLang, currentLanguageInfo, supportLanguageList }
})
